import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../auth/services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const notification = inject(NzNotificationService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage: string[] = [];
      let message: string = 'Настана грешка. \nВе молиме обидете се повторно.';

      // TODO: NO INTERNET CONNECTION ERROR

      if (error.error.errors && error.status === 422) {
        for (const key in error.error.errors) {
          if (error.error.errors.hasOwnProperty(key)) {
            errorMessage.push(error.error.errors[key]);
            message = errorMessage.join(`\n`);
          }
        }
      }
      if (error.error && error.status === 400) {
        message = `${error.error.message}.`;
      }
      if (error.error && error.status === 401) {
        authService.logout();
      }
      notification.error('Грешка', message);
      throw errorMessage;
    })
  );
};
